exports.cs = {
  BACKEND_ERROR: {
    MESSAGE_TITLE: 'Omlouváme se, aplikaci se nepodařilo načíst.',
    MESSAGE_TEXT: 'Zkuste stránku <a onclick="window.location.reload(false);">obnovit</a> nebo nás kontaktujte na bezplatné lince <a href="tel:800207207">800 207 207</a>'
  }
}
